import React from "react";

/* Component imports */
import GameController from "../GameController";
import RoadmapEnlargeButton from "../RoadmapEnlargeButton";

import ToggleSwitch from "../ToggleSwitch";

import LeftSideButtons from "../LeftSideButtons";
import RightSideButtons from "../RightSideButtons";

import VirtualCards from "../VirtualCards";
import VideoOffNotice from "../VideoOffNotice";

import BetConfirmedModal from "../BetConfirmedModal";
import MessageModal from "../MessageModal";
import YouWonModal from "../YouWonModal";

/* End of component imports */

import { IV2Props } from "@/types/GlobalTypes";

// Module imports

import {
	Table,
	History,
	RoadmapLarge,
	RoadmapSmall,
	GameStatistics,

	getTimeText,
	isBetClosed,
} from "@/modules/commonMobile";

import { assetImg } from "@/modules/moduleImporter";

import thousandsFormat from "@/modules/thousandsFormat";
import moneyFormat from "@/modules/moneyFormat";
import { isIPad, isIPadOS } from "@/modules/iOSDetection";
import { 
	getBasePcode,
	getAssetPcode,
	getGameVariantLetter,
	v2games,
} from "@/modules/gamePcode";

// Image imports
import img_more_bet from "@/assets/img/mobile/img_more_bet.png";
import img_less_bet from "@/assets/img/mobile/img_less_bet.png";

import small_history_on from "@/assets/img/small_history_on.png";
import small_history_off from "@/assets/img/small_history_off.png";
import small_roadmap_on from "@/assets/img/small_roadmap_on.png";
import small_roadmap_off from "@/assets/img/small_roadmap_off.png";
import small_minmax_on from "@/assets/img/small_minmax_on.png";
import small_minmax_off from "@/assets/img/small_minmax_off.png";

import img_small_fullscreen from "@/assets/img/svg/sidemenu/fullscreen.svg";

import img_bet_closed_multi_table from "@/assets/img/img_bet_closed_multi_table.png";


interface IState {
	useNewControllerInterface: boolean
}

/**
 * Clone of MaximizeGame with new CSS and features
 */
export default class MaximizeGameV2 extends React.Component<IV2Props, IState> {
	state = { useNewControllerInterface: false }

	render() {
		const activeGame = this.props.data;
		const { userdata } = this.props;

		const pcode = activeGame.pcode,
			basePcode = getBasePcode(pcode),
			assetPcode = getAssetPcode(pcode),

			showMoreBetButton = basePcode === "m22" || basePcode === "m23" || basePcode === "m38";

		const pcodeProp = { pcode: pcode };

		//Updates timer text
		const timeText = getTimeText(this.props.timerData);
		const timer = this.props.timerData ? this.props.timerData.time : 0;
		const betClosed = isBetClosed(timer);

		//Todo: actually change the quality from videoQuality prop
		//Stream object
		const streamObj = activeGame.streamObj;

		const v2ControllerArray = (
			<div className={"controller" +
				(this.state.useNewControllerInterface ? " experimental" : "") +
				(betClosed ? " relaxed" : "")}>
				<GameController
					disabled={activeGame.disableUndoBet}
					clickFunction={this.props.undoBet}
					controllerClass={"sl-red-sh"}
					pcode={pcode}
					controllerValue={this.props.lang["txt_undo"]}

					useHDImage={activeGame.maximised && this.state.useNewControllerInterface}
					HDImagePrefix="btn_undo"
				/>

				<GameController
					disabled={activeGame.disableClearBet}
					clickFunction={this.props.clearBet}
					controllerClass={"sl-blue-sh"}
					pcode={pcode}
					controllerValue={this.props.lang["txt_clear"]}

					useHDImage={activeGame.maximised &&this.state.useNewControllerInterface}
					HDImagePrefix="btn_clear"
				/>

				<GameController
					disabled={activeGame.disableRebet}
					clickFunction={this.props.reBet}
					controllerClass={"sl-yellow-sh"}
					pcode={pcode}
					controllerValue={this.props.lang["txt_rebet"]}

					useHDImage={activeGame.maximised && this.state.useNewControllerInterface}
					HDImagePrefix="btn_rebet"
				/>

				<GameController
					disabled={activeGame.disableSubmitBet}
					clickFunction={this.props.sendBet}
					controllerClass={"sl-green-sh"}
					pcode={pcode}
					controllerValue={this.props.lang["txt_submit"]}

					useHDImage={activeGame.maximised && this.state.useNewControllerInterface}
					HDImagePrefix="btn_submit"
				/>
			</div>
		);

		const periode = activeGame.periode;
		// const shoePeriode = activeGame.shoePeriode;

		const historyObject = activeGame.roadmap ?
			activeGame.roadmap.big_road :
			activeGame.history;

		if (!activeGame.active)
			return null;

		return (
			<div className={
				"sl-game v2" +
				(activeGame.maximised ? " sl-single-game-v2" + (this.props.autoHideHeader ? " header-autohide" : "") : " sl-multi-table") +
				(activeGame.transparentChips ? " transparent-chips" : "") +
				(isIPad() || isIPadOS() ? " ipad" : "")}

				{... { "data-pcode": pcode }}>
				{
					this.props.activeGameCount > 1 ?
						<div className="header">
							{assetImg("game_icon", assetPcode + "_wh.svg", "", "logo")}
							{
								// <img src={this.props.white_icon} alt={activeGame.name} className="logo" />
							}

							<p className="name">
								{
									this.props.lang["txt_game_name_" + basePcode] +
									` ${getGameVariantLetter(pcode)}`
								}
							</p>

							<p className="periode">
								P {periode}
							</p>

							{
								!activeGame.maximised ?
									<img className={"maximise"}
										src={img_small_fullscreen}
										{...pcodeProp}
										onClick={this.props.maximiseGame}
										alt="maximise" />
									: null
							}
							{/* <i className={"sl-ic-close close"}
								{...{ game: pcode }}
								onClick={this.props.closeGame}></i> */}
						</div> : null
				}

				<div className={"stream-container" +
					(this.props.activeGameCount === 1 ? "-fullscreen" : "") +
					(this.props.enableStreaming ? " has-streaming" : " no-streaming")}>

					{this.props.enableStreaming ? streamObj : null}

					<VideoOffNotice
						langdata={this.props.lang}
						enableStreaming={this.props.enableStreaming}
						isLoadingStreaming={this.props.isLoadingStreaming}
						isDesktop={true}
					/>
				</div>

				{ /* Baccarat Roadmaps left part */}

				{
					// Baccarat V3
					activeGame.maximised ?
						<div className={"baccarat-left-container" + (this.props.baccaratDarkMode ? " dark" : "")}>
							<div className="roadmap-container bead-road">
								<RoadmapLarge
									pcode={pcode}
									history={historyObject}
									filter={activeGame.activeRoadmapFilter}
									historyBlink={activeGame.historyBlink}
									baccaratDarkMode={this.props.baccaratDarkMode}
									type={pcode === "m27" ? "shio" : "bead-road"} />
							</div>

							<GameStatistics
								pcode={pcode}
								history={historyObject}
								filters={activeGame.roadmapFilters}
								baccaratDarkMode={this.props.baccaratDarkMode}

								langdata={this.props.lang}
							/>

							<div className="switch-container">
								<ToggleSwitch
									checked={this.props.baccaratDarkMode}
									changeEvent={this.props.toggleDarkMode}
								/>
							</div>
						</div> : null
				}

				{ /* End of Baccarat Roadmaps left part */}



				{
					//Multi table
					//Game History Buttons
					this.props.activeGameCount > 1 ?
						(
							<div className="game-history-buttons">
								<div {...pcodeProp} onClick={this.props.toggleLobbyRoadmap}>
									{
										activeGame.lobbyRoadmap ?
											<img src={small_roadmap_on} alt="roadmap" /> :
											<img src={small_roadmap_off} alt="roadmap" />
									}
								</div>

								<div {...pcodeProp} onClick={this.props.toggleLobbyHistory}>
									{
										activeGame.lobbyHistory ?
											<img src={small_history_on} alt="history" /> :
											<img src={small_history_off} alt="history" />
									}
								</div>
								<div {...pcodeProp} onClick={this.props.toggleLobbyMinMax}>
									{
										activeGame.lobbyMinMax ?
											<img src={small_minmax_on} alt="min-max" /> :
											<img src={small_minmax_off} alt="min-max" />
									}
								</div>
							</div>
						) : null
				}

				{
					//Roadmap options
					//apply roadmap filter on click
					!activeGame.maximised &&
						activeGame.lobbyRoadmap &&
						(activeGame.roadmapFilters.length > 1) ? (
							<div className={"roadmap-options tip"}>
								{
									activeGame.roadmapFilters.map((filter, idx) => (
										<div key={"V2_" + idx}
											className={activeGame.activeRoadmapFilter === filter ? "active" : ""}
											{...{
												game: pcode,
												filter: filter
											}}

											onClick={this.props.setLobbyRoadmapFilter}>
											<div>{idx + 1}</div>
										</div>)
									)
								}


								<span className={activeGame.alwaysShowRoadmapText ? "active" : ""}>
									{activeGame.roadmapText[activeGame.activeRoadmapFilter]}
								</span>
							</div>
						) : null
				}

				{
					/* Roadmap for Multi Table */
					this.props.activeGameCount > 1 && activeGame.lobbyRoadmap ? (
						<RoadmapSmall
							langdata={this.props.lang}
							pcode={pcode}
							history={historyObject}
							historyBlink={activeGame.historyBlink}
							filter={activeGame.activeRoadmapFilter}
							small={true} />
					) : null
				}

				{
					/* Multibet Min Max */
					this.props.activeGameCount > 1 && activeGame.lobbyMinMax ? (
						<div className="min-max-container">
							<table className="table-desc">
								<tbody>
									<tr>
										<td className="desc-heading">{this.props.lang["txt_min_number"]}</td>
										<td>:</td>
										<td className="desc-content">{thousandsFormat(activeGame.min, userdata.user.lang)}</td>
									</tr>
									<tr>
										<td className="desc-heading">{this.props.lang["txt_min_50"]}</td>
										<td>:</td>
										<td className="desc-content">{thousandsFormat(activeGame.min50, userdata.user.lang)}</td>
									</tr>
									<tr>
										<td className="desc-heading">{this.props.lang["txt_max_number"]}</td>
										<td>:</td>
										<td className="desc-content">{thousandsFormat(activeGame.max, userdata.user.lang)}</td>
									</tr>
									<tr>
										<td className="desc-heading">{this.props.lang["txt_max_50"]}</td>
										<td>:</td>
										<td className="desc-content">{thousandsFormat(activeGame.max50, userdata.user.lang)}</td>
									</tr>
								</tbody>
							</table>
						</div>)
						: this.props.activeGameCount > 1 && activeGame.lobbyHistory ?
							<History
								pcode={pcode}
								history={v2games.indexOf(basePcode) >= 0 ? historyObject : activeGame.history}
								historyBlink={activeGame.historyBlink}
								activeGameCount={this.props.activeGameCount}
								mobile={false}
								small={true}
								langdata={this.props.lang}
							/>
							: null
				}

				{
					activeGame.maximised ?
						<LeftSideButtons
							activeGame={activeGame}
							lang={this.props.lang}
							userdata={userdata}
							enableStreaming={this.props.enableStreaming}
							updateSettings={this.props.updateSettings}

							videoQuality={this.props.videoQuality}
							changeVideoQuality={this.props.changeVideoQuality}
						/> : null
				}

				{
					activeGame.maximised ?
						<RightSideButtons
							activeGame={activeGame}
							timerData={this.props.timerData}
							lang={this.props.lang}
							userdata={userdata}
						/> : null
				}

				{
					// V3
					<div className={
						(activeGame.maximised ? "table-container" : "table") +
						(this.state.useNewControllerInterface ?
							(betClosed ? " experimental relaxed" : " experimental") :
							" relaxed")
					}>
						<div className="left-wing"></div>
						<div className="right-wing"></div>

						{
							activeGame.newSet ? (
								<div className="new-shoe-indicator">
									{this.props.lang["txt_new_shoe_message"]}
								</div>
							) : null
						}

						{
							showMoreBetButton &&
								activeGame.maximised ? (
									this.state.useNewControllerInterface ? (
										this.props.completeTable ?
											<div className="bet-toggle"
												onClick={this.props.toggleCompleteTable}>
												{/* Less Bet */}
												<img src={"assets/img/more_less_buttons/btn_more_less.png"} alt="more bet" />
												<div>{this.props.lang["txt_less_bet"]}</div>
											</div> :

											<div className="bet-toggle"
												onClick={this.props.toggleCompleteTable}>
												{/* More Bet */}
												<img src={"assets/img/more_less_buttons/btn_more_less.png"} alt="less bet" />
												<div>{this.props.lang["txt_more_bet"]}</div>
											</div>
									) : (
											this.props.completeTable ?
												<div className="bet-toggle"
													onClick={this.props.toggleCompleteTable}>
													{//<div>Less Bet</div>
													}

													<div>
														{this.props.lang["txt_less_bet"]}
													</div>
													<img src={img_more_bet} alt="more bet" />
												</div> :
												<div className="bet-toggle" onClick={this.props.toggleCompleteTable}>
													<div>
														{ //More Bet
														}
														{this.props.lang["txt_more_bet"]}
													</div>
													<img src={img_less_bet} alt="less bet" />
												</div>
										)
								) : null
						}

						<Table
							pcode={pcode}
							insertBet={this.props.insertBet}
							chipBase={this.props.chipBase}
							data={activeGame}
							langdata={this.props.lang}
							maximised={activeGame.maximised}
							completeTable={this.props.completeTable} />
					</div>
				}

				{
					// Game Controller
					v2ControllerArray
				}

				{
					//Baccarat Roadmap right part
				}

				{
					activeGame.maximised ? (
						activeGame.enlargedRoadmap ? (
							<div className={"baccarat-right-container" + (this.props.baccaratDarkMode ? " dark" : "")}>
								<div className="roadmap-container enlarged">
									<RoadmapLarge
										pcode={pcode}
										history={historyObject}
										filter={activeGame.activeRoadmapFilter}
										historyBlink={activeGame.historyBlink}
										baccaratDarkMode={this.props.baccaratDarkMode}
										type={activeGame.enlargedRoadmap}
										enlarged={true} />

									<RoadmapEnlargeButton
										prop={activeGame.enlargedRoadmap}
										pcode={pcode}
										toggleEnlargeRoadmap={this.props.toggleEnlargeRoadmap}
										reversed={true}
									/>
								</div>
							</div>
						) : (
								<div className={"baccarat-right-container" + (this.props.baccaratDarkMode ? " dark" : "")}>
									<div className="roadmap-container big-road">
										<RoadmapLarge
											pcode={pcode}
											history={historyObject}
											filter={activeGame.activeRoadmapFilter}
											historyBlink={activeGame.historyBlink}
											baccaratDarkMode={this.props.baccaratDarkMode}
											type="big-road" />

										<RoadmapEnlargeButton
											prop="big-road"
											pcode={pcode}
											reversed={false}
											toggleEnlargeRoadmap={this.props.toggleEnlargeRoadmap}
										/>
									</div>

									<br />

									<div className="roadmap-container predictions">
										<RoadmapLarge
											pcode={pcode}
											history={historyObject}
											historyBlink={activeGame.historyBlink}
											filter={activeGame.activeRoadmapFilter}
											type="predictions" />
									</div>
									<div className="roadmap-container group">
										<div className="roadmap-container big-eye-road">
											<RoadmapLarge
												pcode={pcode}
												history={historyObject}
												filter={activeGame.activeRoadmapFilter}
												historyBlink={activeGame.historyBlink}
												baccaratDarkMode={this.props.baccaratDarkMode}
												type="big-eye-road" small={true} />

											<RoadmapEnlargeButton
												prop="big-eye-road"
												pcode={pcode}
												reversed={false}
												toggleEnlargeRoadmap={this.props.toggleEnlargeRoadmap}
											/>
										</div>

										<div className="roadmap-container small-road">
											<RoadmapLarge
												pcode={pcode}
												history={historyObject}
												filter={activeGame.activeRoadmapFilter}
												historyBlink={activeGame.historyBlink}
												baccaratDarkMode={this.props.baccaratDarkMode}
												type="small-road" small={true} />

											<RoadmapEnlargeButton
												prop="small-road"
												pcode={pcode}
												reversed={false}
												toggleEnlargeRoadmap={this.props.toggleEnlargeRoadmap}
											/>
										</div>

										<div className="roadmap-container cockroach-road">
											<RoadmapLarge
												pcode={pcode}
												history={historyObject}
												filter={activeGame.activeRoadmapFilter}
												historyBlink={activeGame.historyBlink}
												baccaratDarkMode={this.props.baccaratDarkMode}
												type="cockroach-road" small={true} />

											<RoadmapEnlargeButton
												prop="cockroach-road"
												pcode={pcode}
												reversed={false}
												toggleEnlargeRoadmap={this.props.toggleEnlargeRoadmap}
											/>
										</div>
									</div>
								</div>
							)
					) : null
				}

				{
					//End of Baccarat Roadmap right part
				}


				{
					!activeGame.maximised ?
						<div className="group-timer">
							<div className={"timer" +
								(
									betClosed ?
										" bet-closed" :
										(this.props.timerData.time > 5) ? " bet-open" : " bet-closing")}>
								{
									betClosed ?
										<img src={img_bet_closed_multi_table} alt="bet closed" /> :
										timeText
								}
							</div>

							<div className="total-bet">
								<p className="desc-heading">{this.props.lang["txt_total_bet"]}:&nbsp;</p>
								<p className="desc-content">
									{
										this.props.activeGameCount === 1 ?
											moneyFormat(activeGame.totalBet, userdata.user.lang, userdata.user.currency) :
											thousandsFormat(activeGame.totalBet, userdata.user.lang)
									}
								</p>
							</div>
						</div> : null
				}

				{
					//Virtual Cards
					basePcode === "m22" ||
						basePcode === "m23" ||
						basePcode === "m27" ||
						basePcode === "m28" ||
						basePcode === "m38" ? (
							<VirtualCards
								activeGame={activeGame}
								virtualCardScanResult={activeGame.virtualCardScanResult} />
						) : null
				}

				{ /* MODALS */}
				{
					activeGame.betConfirmedModal ?
						<BetConfirmedModal
							message={activeGame.betConfirmedModal.message}

							pcode={activeGame.pcode}
							onClose={this.props.clearModalsWithPcode}
						/> : null
				}

				{
					activeGame.messageModal ?
						<MessageModal
							message={activeGame.messageModal.message}

							pcode={activeGame.pcode}
							onClose={this.props.clearModalsWithPcode}
						/> : null
				}

				{
					activeGame.winModal ?
						<YouWonModal
							langStr={this.props.lang.language_code}
							winamount={activeGame.winModal.winAmount}
						/> : null
				}
			</div>
		);
	}
}
